<template>
  <header>
    <v-container grid-list-md class="cabecera">
      <v-layout row wrap class="header">
        <v-flex xs1 sm4 md4 lg4>
          <img src="@/resources/img/CNMC-logo-sede.png" width="100%" class="big" />
          <img src="@/resources/img/cnmc-logo.png" width="100%" class="medium" />
        </v-flex>
        <v-flex xs1 sm2 md4 lg4>
          <v-layout row align-center>
            <v-flex shrink>
              <img src="@/resources/img/BDDI-logo.png" height="80px" class="logo" />
            </v-flex>
            <v-flex grow>
              <div class="titulo">Tasas y Cuotas</div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs10 sm6 md4 lg4>
          <v-layout row wrap fill-height reverse="true" v-if="autenticado">
            <v-flex xs2 class="avatar">
              <v-icon size="60" color="primary">account_circle</v-icon>
            </v-flex>
            <v-flex class="user">
              <div class="infoUser">{{ userName }}</div>
              <div class="infoBrowser">{{ browserInfo }}</div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </header>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      userName: 'userName',
      browserInfo: 'browserInfo',
      autenticado: 'userAuthenticated',
      rolesUsuario: 'rolesUsuario'
    })
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import 'src/resources/styles/variables.scss';

header {
  background-color: #f7f7f5;
}

.avatar {
  font-size: 50px;
  color: $color-primary;
}

.titulo {
  color: $color-primary;
  text-align: left;
}

.user {
  float: right;
  text-align: right;
  margin: 10px;
}

.infoBrowser {
  font-size: 14px;
  color: $color-text-secondary;
}

.infoUser {
  font-size: 16px;
  margin-top: 5px;
  color: #48576a !important;
  font-weight: bold;
}

@media (min-width: 960px) {
  .big {
    display: block;
  }

  .medium {
    display: none;
  }
  .titulo {
    font-size: 30px;
  }
}

@media (min-width: 601px) and (max-width: 959px) {
  .big {
    display: none;
  }

  .medium {
    display: block;
  }
  .titulo {
    font-size: 20px;
  }
  .logo {
    display: none;
  }
}

@media (max-width: 600px) {
  .big {
    display: none;
  }

  .medium {
    display: none;
  }
  .titulo {
    display: none;
  }
}
</style>
